import React, { useRef, useState } from "react";
import { Upload, X, FileText } from "lucide-react";
import { Button } from "../ui/button";

export const DocumentPicker = ({ files, setFiles, disabled, prefix = "practice" }) => {
  const input = useRef(null);
  const [error, setError] = useState("");
  function add(selected) {
    setError("");
    const next = [...files];
    for (const file of selected) {
      if (file.size > 25 * 1024 * 1024 || !file.size) { setError("Sono ammessi file non vuoti fino a 25 MB."); continue; }
      if (!next.some(f => f.name === file.name && f.size === file.size && f.lastModified === file.lastModified)) next.push(file);
    }
    if (next.length > 15) setError("Puoi caricare fino a 15 documenti per volta.");
    setFiles(next.slice(0, 15));
  }
  return <div className="document-picker">
    <button type="button" className="practice-drop" disabled={disabled} data-testid={`${prefix}-dropzone`} onClick={() => input.current?.click()} onDragOver={e => e.preventDefault()} onDrop={e => { e.preventDefault(); if (!disabled) add(Array.from(e.dataTransfer.files)); }}>
      <Upload size={24} /><strong>Seleziona o trascina i documenti</strong><span>Fino a 15 file · 25 MB ciascuno</span>
    </button>
    <input ref={input} type="file" multiple hidden disabled={disabled} data-testid={`${prefix}-file-input`} onChange={e => { add(Array.from(e.target.files || [])); e.target.value = ""; }} />
    {!!files.length && <ul className="selected-files" data-testid={`${prefix}-selected-files`}>{files.map((file, i) => <li key={`${file.name}-${i}`} data-testid={`${prefix}-selected-${i}`}><FileText size={15} /><span>{file.name}</span><small>{Math.max(1, Math.round(file.size / 1024))} KB</small><Button type="button" variant="ghost" size="icon" title="Rimuovi dalla selezione" disabled={disabled} data-testid={`${prefix}-remove-${i}`} onClick={() => setFiles(files.filter((_, index) => i !== index))}><X size={15} /></Button></li>)}</ul>}
    {error && <div role="alert" className="error" data-testid={`${prefix}-selection-error`}>{error}</div>}
  </div>;
};